/* eslint-disable camelcase */
/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

const whitespacesReg = /^\s*\S.*$/;

export const getValidationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required('Required.')
      .max(35, 'Too many characters.')
      .matches(whitespacesReg, 'The field cannot contain only spaces.'),
    lastName: Yup.string()
      .required('Required.')
      .max(35, 'Too many characters.')
      .matches(whitespacesReg, 'The field cannot contain only spaces.'),
    email: Yup.string()
      .required('Please fill out the rest fields. This is mandatory.')
      .email('Email is invalid'),
  });
